module.exports = __webpack_public_path__ + "7773a5c55d378079c573b3cc5321bbd1.svg";